import { useI18nContext } from "@hopper-b2b/i18n";
import "./styles.scss";
import { ContactInfoForm, IContactInfo } from "@hopper-b2b/checkout";

export interface IContactInformationBlock {
  onContactInfoChange: (contactInfo: IContactInfo) => void;
  contactInfo: IContactInfo;
}

export const ContactInformationBlock = (props: IContactInformationBlock) => {
  const { onContactInfoChange, contactInfo } = props;
  const { t } = useI18nContext();

  return (
    <div className="checkout-contact-info-block checkout-block">
      <ContactInfoForm
        title={t("contactInformation")}
        onContactInfoChange={onContactInfoChange}
        contactInfo={contactInfo}
      />
    </div>
  );
};
